import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import invariant from '../utils/invariant';

function createNavigator(NavigatorView, router, navigationConfig) {
  var Navigator = /*#__PURE__*/function (_React$Component) {
    _inherits(Navigator, _React$Component);

    var _super = _createSuper(Navigator);

    function Navigator() {
      var _this;

      _classCallCheck(this, Navigator);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", {
        descriptors: {},
        screenProps: _this.props.screenProps
      });

      return _this;
    }

    _createClass(Navigator, [{
      key: "render",
      value: function render() {
        return React.createElement(NavigatorView, _extends({}, this.props, {
          screenProps: this.state.screenProps,
          navigation: this.props.navigation,
          navigationConfig: navigationConfig,
          descriptors: this.state.descriptors
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(nextProps, prevState) {
        var prevDescriptors = prevState.descriptors;
        var navigation = nextProps.navigation,
            screenProps = nextProps.screenProps;
        invariant(navigation != null, 'The navigation prop is missing for this navigator. In react-navigation 3 you must set up your app container directly. More info: https://reactnavigation.org/docs/en/app-containers.html');
        var state = navigation.state;
        var routes = state.routes;

        if (typeof routes === 'undefined') {
          throw new TypeError('No "routes" found in navigation state. Did you try to pass the navigation prop of a React component to a Navigator child? See https://reactnavigation.org/docs/en/custom-navigators.html#navigator-navigation-prop');
        }

        var descriptors = {};
        routes.forEach(function (route) {
          if (prevDescriptors && prevDescriptors[route.key] && route === prevDescriptors[route.key].state && screenProps === prevState.screenProps) {
            descriptors[route.key] = prevDescriptors[route.key];
            return;
          }

          var getComponent = router.getComponentForRouteName.bind(null, route.routeName);
          var childNavigation = navigation.getChildNavigation(route.key);
          var options = router.getScreenOptions(childNavigation, screenProps);
          descriptors[route.key] = {
            key: route.key,
            getComponent: getComponent,
            options: options,
            state: route,
            navigation: childNavigation
          };
        });
        return {
          descriptors: descriptors,
          screenProps: screenProps
        };
      }
    }]);

    return Navigator;
  }(React.Component);

  _defineProperty(Navigator, "router", router);

  _defineProperty(Navigator, "navigationOptions", navigationConfig.navigationOptions);

  return Navigator;
}

export default createNavigator;